/* Basis motion engine. Motion always reveals data, never decorates. */
(function () {
  'use strict';
  var noMotion =
    document.body.classList.contains('bx-no-motion') ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  function finalizeCounter(el) {
    el.textContent = el.getAttribute('data-bx-format') || el.getAttribute('data-bx-count');
  }
  function formatNum(v, decimals, useSep) {
    var s = v.toFixed(decimals);
    if (useSep) {
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      s = parts.join('.');
    }
    return s;
  }

  /* ---------- count-up (500ms) ---------- */
  function runCounter(el) {
    var target = parseFloat(el.getAttribute('data-bx-count'));
    if (isNaN(target)) return;
    var decimals = parseInt(el.getAttribute('data-bx-decimals') || '0', 10);
    var useSep = (el.getAttribute('data-bx-count') || '').length > 3 || target >= 1000;
    var dur = 500;
    var t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = formatNum(target * eased, decimals, useSep);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = formatNum(target, decimals, useSep);
    }
    requestAnimationFrame(step);
  }

  /* ---------- line / sparkline trace (500ms) ---------- */
  function tracePath(path) {
    var len;
    try { len = path.getTotalLength(); } catch (e) { return; }
    path.style.strokeDasharray = len + ' ' + len;
    path.style.strokeDashoffset = len;
    path.getBoundingClientRect();
    path.style.transition = 'stroke-dashoffset 500ms cubic-bezier(.22,.61,.2,1)';
    path.style.strokeDashoffset = '0';
  }

  /* ---------- observer ---------- */
  var counters = document.querySelectorAll('[data-bx-count]');
  var lines = document.querySelectorAll('.bx-trace');
  var reveals = document.querySelectorAll('.bx-reveal');
  var bars = document.querySelectorAll('.bx-bar, .bx-barval');

  if (noMotion) {
    counters.forEach(finalizeCounter);
    reveals.forEach(function (el) { el.classList.add('bx-in'); });
    bars.forEach(function (el) { el.classList.add('bx-in'); });
    /* traces stay at final rendered state: nothing to do */
  } else if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        if (el.hasAttribute('data-bx-count')) runCounter(el);
        else if (el.classList.contains('bx-trace')) tracePath(el);
        else el.classList.add('bx-in');
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -40px 0px' });
    counters.forEach(function (el) { io.observe(el); });
    lines.forEach(function (el) { io.observe(el); });
    reveals.forEach(function (el) { io.observe(el); });
    bars.forEach(function (el) { io.observe(el); });
  } else {
    counters.forEach(finalizeCounter);
    reveals.forEach(function (el) { el.classList.add('bx-in'); });
    bars.forEach(function (el) { el.classList.add('bx-in'); });
  }

  /* ---------- chart tooltips ---------- */
  var tip = document.getElementById('bx-tooltip');
  if (tip) {
    document.addEventListener('pointerover', function (e) {
      var t = e.target.closest('[data-bx-tip]');
      if (!t) return;
      tip.textContent = t.getAttribute('data-bx-tip');
      tip.classList.add('on');
      tip.setAttribute('aria-hidden', 'false');
    });
    document.addEventListener('pointermove', function (e) {
      if (!tip.classList.contains('on')) return;
      var x = Math.min(e.clientX + 14, window.innerWidth - tip.offsetWidth - 8);
      tip.style.left = x + 'px';
      tip.style.top = (e.clientY - tip.offsetHeight - 12) + 'px';
    });
    document.addEventListener('pointerout', function (e) {
      if (e.target.closest && e.target.closest('[data-bx-tip]')) {
        tip.classList.remove('on');
        tip.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /* ---------- article: progress bar ---------- */
  var prog = document.querySelector('.bx-progress i');
  if (prog) {
    var onScroll = function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      prog.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + '%';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- article: TOC build + scrollspy ---------- */
  var tocBox = document.getElementById('bx-toc-list');
  var prose = document.querySelector('.bx-prose');
  if (tocBox && prose) {
    var heads = prose.querySelectorAll('h2');
    if (!heads.length) {
      var tocWrap = document.querySelector('.bx-toc');
      if (tocWrap) tocWrap.style.display = 'none';
    } else {
      var links = [];
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'sec-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        tocBox.appendChild(a);
        links.push(a);
      });
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var id = en.target.id;
          links.forEach(function (a) {
            a.classList.toggle('on', a.getAttribute('href') === '#' + id);
          });
        });
      }, { rootMargin: '-15% 0px -70% 0px' });
      heads.forEach(function (h) { spy.observe(h); });
    }
  }

  /* ---------- mobile nav ---------- */
  var burger = document.getElementById('bx-burger');
  var mnav = document.getElementById('bx-mnav');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();
